@if (filteredItems) {
  <p-table
    #itemTable
    [globalFilterFields]="[
      'entityTypeLabel',
      'actionLabel',
      'userLabel',
      'description',
    ]"
    [loading]="loading"
    [paginator]="true"
    [sortField]="'createdAt'"
    [sortOrder]="-1"
    [rows]="10"
    [rowsPerPageOptions]="[10, 25, 50]"
    [value]="filteredItems">
    <ng-template pTemplate="caption">
      <app-table-list-caption
        [showRangeFilter]="true"
        [showAddButton]="false"
        [searchWord]="searchWord"
        [fromDate]="fromDate"
        [toDate]="toDate"
        (clearTable)="clear(itemTable)"
        (fromDateChange)="onFromDateChange($event)"
        (toDateChange)="onToDateChange($event)"
        (search)="
          itemTable.filterGlobal($event, 'contains')
        "></app-table-list-caption>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th>
          <span class="flex gap-2 align-items-center"
            ><i class="fas fa-database"></i> Was</span
          >
        </th>
        <th>
          <span class="flex gap-2 align-items-center"
            ><i class="fas fa-bolt"></i> Aktion</span
          >
        </th>
        <th>
          <span class="flex gap-2 align-items-center"
            ><i class="fas fa-calendar-day"></i> Wann</span
          >
        </th>
        <th>
          <span class="flex gap-2 align-items-center"
            ><i class="fas fa-user-circle"></i> Wer</span
          >
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr
        class="history-row"
        pTooltip="Details anzeigen"
        tooltipPosition="top"
        (click)="openDetail(item)">
        <td>
          <span class="flex flex-column">
            <span class="flex gap-2 align-items-center">
              <i [class]="item.entityTypeIcon"></i>
              {{ item.entityTypeLabel }}
            </span>
            @if (item.description) {
              <span class="text-color-secondary text-sm">{{
                item.description
              }}</span>
            }
          </span>
        </td>
        <td>
          <span class="flex gap-3 align-items-center">
            <i [class]="item.actionIcon"></i>
            {{ item.actionLabel }}
          </span>
        </td>
        <td>
          <span class="flex gap-2 align-items-center">
            <i class="fas fa-calendar-day"></i>
            {{ item.createdAt * 1000 | date: "dd.MM.yyyy', ' HH:mm" }}
          </span>
        </td>
        <td>
          <span class="flex gap-2 align-items-center">
            <p-avatar
              shape="circle"
              size="normal"
              [image]="
                getUserImagePath(item.resolvedUser) || undefined
              "
              [label]="
                getUserImagePath(item.resolvedUser)
                  ? undefined
                  : getUserInitial(item.resolvedUser)
              "></p-avatar>
            {{ item.userLabel }}
          </span>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <p-dialog
    header="Details"
    [visible]="!!selectedItem"
    (visibleChange)="onDialogVisibleChange($event)"
    [modal]="true"
    [dismissableMask]="true"
    [style]="{ width: '28rem' }">
    @if (selectedItem) {
      <div class="flex flex-column gap-3">
        <div>
          <div class="text-color-secondary text-sm">Was</div>
          <span class="flex gap-2 align-items-center">
            <i [class]="selectedItem.entityTypeIcon"></i>
            {{ selectedItem.entityTypeLabel }}
          </span>
        </div>
        <div>
          <div class="text-color-secondary text-sm">Aktion</div>
          <span class="flex gap-2 align-items-center">
            <i [class]="selectedItem.actionIcon"></i>
            {{ selectedItem.actionLabel }}
          </span>
        </div>
        @if (selectedItem.description) {
          <div>
            <div class="text-color-secondary text-sm">Beschreibung</div>
            <span>{{ selectedItem.description }}</span>
          </div>
        }
        <div>
          <div class="text-color-secondary text-sm">Wann</div>
          <span>{{
            (selectedItem.createdAt ?? 0) * 1000
              | date: "dd.MM.yyyy', ' HH:mm"
          }}</span>
        </div>
        <div>
          <div class="text-color-secondary text-sm">Wer</div>
          <span class="flex gap-2 align-items-center">
            <p-avatar
              shape="circle"
              size="normal"
              [image]="
                getUserImagePath(selectedItem.resolvedUser) || undefined
              "
              [label]="
                getUserImagePath(selectedItem.resolvedUser)
                  ? undefined
                  : getUserInitial(selectedItem.resolvedUser)
              "></p-avatar>
            {{ selectedItem.userLabel }}
          </span>
        </div>
        @if (selectedItem.entityId) {
          <div>
            <div class="text-color-secondary text-sm">Datensatz-ID</div>
            <span class="text-sm">{{ selectedItem.entityId }}</span>
          </div>
        }
      </div>
    }
  </p-dialog>
} @else {
  <div role="alert" class="p-message p-message-info">
    <div class="p-message-wrapper">
      <span class="p-message-summary">404</span>
      <span class="p-message-detail">Keine History gefunden</span>
    </div>
  </div>
}
